Core.Map = function(elem) {
    var canvas = elem ? elem : document.getElementById("google-map-canvas");
    var map = null;
    var zoomLevel = 4;
    var lat = -28.926;
    var lng = 134.175;


    /*


        METHODS


     */

    var m = {
        init: function() {
            m.createMap();
        },

        createMap: function () {
            var options = {
                disableDefaultUI: true,
                scrollWheel: false,
                draggable: true,
                streetViewControl: false,
                zoom: zoomLevel,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                minZoom: 1,
                center: new google.maps.LatLng(lat, lng),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            map = new google.maps.Map(canvas, options);
            canvas.classList.add('inited');
        },

        /*
         * @param data { Latitude:string, Longitude: string, Name: string}[]
         * @return void
         */
        plotMarkers: function (data) {
            data.forEach(function(item) {
                new google.maps.Marker({
                    position: new google.maps.LatLng(item.Latitude, item.Longitude),
                    map: map,
                    title: item.Name,
                    icon: Core.Config.StoreFinder.MarkerIconPath
                });
            });
        },

        resetCenter: function() {
            map.setCenter({ lat: lat, lng: lng });
            map.setZoom(Core.IsMobile() ? 3 : 4);
        },

        setState: function(state) {
            var lat, lng, zoomLevel;

            switch (state) {
                case 'act':
                    if (Core.IsMobile()) {
                        zoomLevel = 6;
                    } else {
                        zoomLevel = 7;
                    }
                    lat = -35.308;
                    lng = 149.124;
                    break;
                case 'nsw':
                    zoomLevel = 6;
                    lat = -33.253;
                    lng = 148.921;
                    break;
                case 'vic':
                    zoomLevel = 7;
                    if ( Core.IsMobile()) {
                        lat = -37.471;
                        lng = 144.785;
                    } else {
                        lat = -36.390;
                        lng = 144.235;
                    }
                    break;
                case 'qld':
                    zoomLevel = 6;
                    if (Core.IsMobile()) {
                        lat = -25.917;
                        lng = 151.702;
                    } else {
                        lat = -23.803;
                        lng = 145.571;
                    }
                    break;
                case 'sa':
                    if (Core.IsMobile()){
                        zoomLevel = 5;
                        lat = -30.000;
                        lng = 136.209;
                    } else {
                        zoomLevel = 6;
                        lng = 134.989;
                        lat = -31.566;
                    }
                    break;
                case 'wa':
                    if ( Core.IsMobile() ) {
                        zoomLevel = 5;
                        lat = -24.1249304;
                        lng = 111.9433776;
                    } else {
                        zoomLevel = 6;
                        lat = -30.422;
                        lng = 117.0266;
                    }
                    break;
                case 'tas':
                    zoomLevel = 7;
                    lat = -41.965;
                    lng = 146.628;
                    break;
                case 'nt':
                    zoomLevel = 5;
                    lat = -19.491;
                    lng = 133.550;
                    break;
                default:
                    if (Core.IsMobile()) {
                        zoomLevel = 3;
                    } else {
                        zoomLevel = 4;
                    }
                    lat = -28.926;
                    lng = 134.175;
                    break;
            }

            map.setCenter({ lat: lat, lng: lng });
            map.setZoom(zoomLevel);
        },

        goTo: function(_lat, _lng) {
            lat = new Number(_lat);
            lng = new Number(_lng);
            map.setCenter(new google.maps.LatLng(lat, lng));
            map.setZoom(15);
        },

        initList: function(mapList) {
            function initGeneric(elem) {
                var _map = new Core.Map(elem);
                _map.init();

                if (!elem.dataset || !elem.dataset.lng || !elem.dataset.lat) {
                    return;
                }

                _map.plotMarkers([{
                  "Longitude": elem.dataset.lng,
                  "Latitude": elem.dataset.lat,
                  "Name": elem.dataset.name || '',
                }]);

                _map.goTo(elem.dataset.lat, elem.dataset.lng)
            }


            Array.from(mapList).forEach(initGeneric);
        },
    };

    return m;
};
